<template>
  <a-layout>
    <a-layout-content class="py-12">
      <div class="row">
        <img src="@/assets/logo-wheezo-vert.svg" />
      </div>
      <div class="row">
        <div class="px-4" style="width: 750px">
          <a-card class="my-12 text-center" :bordered="false">
            <a-spin :spinning="loading" size="large">
              <template slot="indicator">
                <div>
                  <lottie :options="loadingAnimationOptions" />
                </div>
              </template>
              <a-form :form="form" v-on:submit.prevent="handleLogin">
                <h3 class="mb-10">Enter your wheezo share code here</h3>
                <a-form-item class="mb-10">
                  <a-input
                    size="large"
                    placeholder="6 character share code"
                    class="sharecode-input"
                    v-decorator="[
                      'shareCode',
                      {
                        rules: [
                          {
                            min: formSubmitted ? 6 : null,
                            max: 6,
                            message: 'The share code must be 6 characters'
                          },
                          {
                            required: true,
                            message: 'Please enter a 6 character share code'
                          }
                        ]
                      }
                    ]"
                  />
                </a-form-item>
                <a-button type="primary" size="large" html-type="submit">
                  View shared history
                </a-button>
              </a-form>
            </a-spin>
          </a-card>
        </div>
      </div>
      <div class="row">
        <div class="px-8 text-center" style="width: 650px">
          <p @click="displayMoreInfo = !displayMoreInfo" class="row items-center mb-4 link">
            <span>What's this?</span>
            <img class="ml-2" src="@/assets/help-circle.svg" />
          </p>
          <transition-group name="more-info">
            <p key="1" v-if="displayMoreInfo" class="caption">
              Users of the Respiri wheezo app have the ability to share their asthma history. This
              is done using a unique one time use 6-digit code that expires within 24 hours of
              creation.
            </p>
          </transition-group>
          <p class="caption mt-6">
            <a href="http://wheezo.com/share/privacy" target="_blank">
              Privacy Policy
            </a>
          </p>
          <p class="caption">
            <a href="http://wheezo.com/share/terms" target="_blank">
              Terms and Conditions
            </a>
          </p>
        </div>
      </div>
    </a-layout-content>
    <a-layout-footer class="caption text-center">
      &copy; 2019 Respiri Limited. All rights reserved.
    </a-layout-footer>
  </a-layout>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AUTHENTICATE } from '@/store';

// eslint-disable-next-line
import Lottie from "vue-lottie";
import * as loaderColor from '@/assets/loader-color.json';

@Component({
  components: {
    lottie: Lottie
  }
})
export default class HomePage extends Vue {
  displayMoreInfo = false;
  loading = false;
  formSubmitted = false;
  loadingAnimationOptions = {
    animationData: loaderColor.default
  };

  beforeCreate() {
    this.form = this.$form.createForm(this);
  }

  handleLogin(event) {
    this.formSubmitted = true;
    this.form.validateFields((error, values) => {
      if (values.shareCode.length != 6) {
        const value = this.form.getFieldValue('shareCode');
        return this.form.setFields({
          shareCode: {
            value,
            errors: [{ message: 'Please enter a 6 character share code' }]
          }
        });
      }
      if (!error) {
        this.loading = true;
        this.$store
          .dispatch(AUTHENTICATE, values.shareCode)
          .then(() => this.$router.push({ name: 'dashboard' }))
          .catch(err => {
            const value = this.form.getFieldValue('shareCode');
            this.loading = false;
            this.form.setFields({
              shareCode: { value, errors: [{ message: err.message }] }
            });
          });
      }
    });
  }
}
</script>
<style lang="postcss" scoped>
.row {
  @apply flex justify-center;
}
.sharecode-input {
  text-transform: uppercase;
}
.sharecode-input:placeholder-shown {
  text-transform: none;
}
.more-info-enter-active,
.more-info-leave-active {
  transition: opacity 0.5s;
}
.more-info-enter,
.more-info-leave-to {
  opacity: 0;
}
.link {
  color: #1976d2;
  cursor: pointer;
}
</style>
